module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sustainabilityOverview":"Sustainability Overview","monthlyStatistics":"Monthly Statistics","disposal":"Waste","electricityDevelopment":"Development, Electricity","heatingDevelopment":"Development, Heating","waterDevelopment":"Development, Water","wasteDevelopment":"Development, Waste","dataProvidedBy":"Data provided by"}}')
  delete Component.options._Ctor
}
